/* eslint-disable jsx-a11y/label-has-associated-control,no-alert */
import React, { useState } from 'react';
import styles from './hero.module.css';
import animateStyles from '../animate.module.css';

const assertBaseUrl = process.env.REACT_APP_ASSETS_BASE_URL;

const phoneNormalizer = (value, previousValue) => (value === ''
|| (/^[^±!@£$%^&*_§¡€#¢§¶•ªº«\\/<>?:;|=.,a-zA-Z]{1,25}$/.test(value)
  && value.trim() !== '' && (value.length - value.trim().length) < 2) ? value : previousValue);

const Hero = () => {
  const [phone, setPhone] = useState('');

  const phoneChangeHandler = (event) => {
    const current = event.target.value;
    const normalizedValue = phoneNormalizer(current, phone);
    event.preventDefault();

    setPhone(normalizedValue);
    // eslint-disable-next-line no-param-reassign
    event.target.value = normalizedValue;
  };

  const getMobileOperatingSystem = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    if (/android/i.test(userAgent)) {
      return 'android';
    }

    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return 'ios';
    }

    return 'unknown';
  };

  const handleEnter = (event) => {
    if (event.keyCode === 13) { //the Enter key
      event.preventDefault();
      handleSendMsg();//execute submit
    }
  };

  const handleSendMsg = () => {
    if (phone.length === 0) {
      alert('Please enter a valid phone number');
    } else {
      const generalErrorMsg = 'We are unable to send SMS to your number. Please try again later';
      fetch(`${process.env.REACT_APP_MESSAGE_API_URL}/api/1/get-the-app`,
        {
          credentials: 'include',
          method: 'POST',
          body: JSON.stringify({
            platform: getMobileOperatingSystem(),
            to_number: encodeURI(phone),
          }),
        })
        .then((response) => {
          if (response.ok) {
            alert('Thank you! You will receive the download link via SMS shortly!');
          } else {
            // eslint-disable-next-line no-console
            console.error(response);
            alert(generalErrorMsg);
          }
        }).catch((e) => {
        // eslint-disable-next-line no-console
          console.error(e);
          alert(generalErrorMsg);
        });
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <h1 className={styles.title}>Download the Free FabFitFun App Today</h1>
        <div className={styles.sms}>
          <label className={styles['sms-label']}>
            Text download link to your phone:
          </label>
          <form action="" className={styles['sms-form']}>
            <input
              type="text"
              placeholder="(555)555-5555"
              className={styles['sms-input']}
              onChange={phoneChangeHandler}
              onKeyDown={handleEnter}
            />
            <button
              type="button"
              id="submit-number-btn"
              className={styles['sms-button']}
              onClick={handleSendMsg}
            >
              SEND
            </button>
          </form>
        </div>
        <div className={styles['app-downloads']}>
          <a
            href={process.env.REACT_APP_MOBILE_APP_IOS_URL}
            className={styles['app-cta']}
          >
            <img
              src={`${assertBaseUrl}/images/cta_apple_1574120300.7234_1574120301.1535.png`}
              alt=""
              className={animateStyles.hoverbtn}
            />
          </a>
          <a
            href={process.env.REACT_APP_MOBILE_APP_ANDROID_URL}
            className={styles['app-cta']}
          >
            <img
              src={`${assertBaseUrl}/images/cta_android_1574120299.0486_1574120299.4814.png`}
              alt=""
              className={animateStyles.hoverbtn}
            />
          </a>
        </div>
      </div>
      <div className={styles['hero-img']}>
        <img
          src={`${assertBaseUrl}/images/fff-flatlay2.jpeg`}
          alt=""
          className={`${animateStyles.animate} ${animateStyles.fadeinright}`}
        />
      </div>
    </div>
  );
};

export default Hero;
